// ============================================================================
// Table Columns: Skills
// Key: skills
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	relationCountRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	ExtendedUserDto,
	SkillGroupSkillDto,
	SkillGroupSummary,
	SkillSummary,
	TeamSkillResponse,
	TeamSummary,
} from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const skillsListColumnsConfig = {
	columns: [
		'name',
		relationCountRenderer('userCount', 'users'),
		relationCountRenderer('teamCount', 'teams'),
		cellRenderer('templateCount', 'number'),
		relationCountRenderer('skillGroupCount', 'skillGroups'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: SkillSummary) => `/skills/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<SkillSummary>
// #endregion

// #region Relation List Columns
// #region Relation: SkillGroups
export const skillsRelationsSkillGroupsAssignedColumnsConfig = {
	columns: ['skillName', 'skillGroupName'],
} as const satisfies EntityTableConfig<SkillGroupSkillDto>
export const skillsRelationsSkillGroupsAvailableColumnsConfig = {
	columns: [
		'name',
		cellRenderer('userCount', 'number'),
		cellRenderer('teamCount', 'number'),
		cellRenderer('skillCount', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
} as const satisfies EntityTableConfig<SkillGroupSummary>
// #endregion

// #region Relation: Teams
export const skillsRelationsTeamsAssignedColumnsConfig = {
	columns: ['teamName', 'skillName', cellRenderer('isInherited', 'boolean')],
} as const satisfies EntityTableConfig<TeamSkillResponse>
export const skillsRelationsTeamsAvailableColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'name',
		cellRenderer('isDefaultTeam', 'boolean'),
		'userGroup',
		'responsibleUserGroup',
		cellRenderer('userCount', 'number'),
		cellRenderer('queueCount', 'number'),
		cellRenderer('skillCount', 'number'),
		cellRenderer('customPageCount', 'number'),
		cellRenderer('skillGroupCount', 'number'),
	],
} as const satisfies EntityTableConfig<TeamSummary>
// #endregion

// #region Relation: Users
export const skillsRelationsUsersAssignedColumnsConfig = {
	columns: [
		cellRenderer('skillLevel', 'number'),
		'skillName',
		'userFirstName',
		'userLastName',
		'userEmail',
		'userLogonName',
		'firstName',
		'lastName',
		'email',
		cellRenderer('isDisabled', 'boolean'),
		'logonName',
		'extension',
		'customProperty1',
		'customProperty2',
		'customProperty3',
		'customProperty4',
		'customProperty5',
		cellRenderer('teams', 'list'),
	],
} as const satisfies EntityTableConfig<ExtendedUserDto>
export const skillsRelationsUsersAvailableColumnsConfig = {
	columns: [
		'firstName',
		'lastName',
		'email',
		cellRenderer('isDisabled', 'boolean'),
		'logonName',
		'extension',
		'customProperty1',
		'customProperty2',
		'customProperty3',
		'customProperty4',
		'customProperty5',
		cellRenderer('teams', 'list'),
		cellRenderer('skillLevel', 'number'),
	],
} as const satisfies EntityTableConfig<ExtendedUserDto>
// #endregion
// #endregion

// #region Columns Config Export
export const skillsColumnsConfig = {
	list: skillsListColumnsConfig,
	relations: {
		skillGroups: {
			assigned: skillsRelationsSkillGroupsAssignedColumnsConfig,
			available: skillsRelationsSkillGroupsAvailableColumnsConfig,
		},
		teams: {
			assigned: skillsRelationsTeamsAssignedColumnsConfig,
			available: skillsRelationsTeamsAvailableColumnsConfig,
		},
		users: {
			assigned: skillsRelationsUsersAssignedColumnsConfig,
			available: skillsRelationsUsersAvailableColumnsConfig,
		},
	},
} as const
// #endregion
